import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { AuthHttpService } from 'app/shared/auth-http.service'
import { Observable } from 'rxjs'
import { IVehicleWire } from 'app/vehicles/vehicles.interfaces'
import { EnvironmentService } from 'app/environment.service';
import { toParamsObj } from 'app/shared/utils';

@Injectable()
export class VehicleService {

    constructor(private http: HttpClient, private authhttp: AuthHttpService, private environmentService: EnvironmentService, ) {

    }
    public getVehiclesFromReservation(reservationCode: string): Observable<IVehicleWire> {
        let params = { 'reservationCode': reservationCode }
        const url = `${this.environmentService.getSbServiceUrl()}/api/vehicles-amendment/`
        return this.authhttp.get(url, { params: toParamsObj(params) })
    }
}
